module.exports = __webpack_public_path__ + "static/media/2ATH3BK.crop.c4c63c8d.jpg";